import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'pdhstar-card-manager-admin-navigation',
    templateUrl: './admin-navigation.component.html',
    styleUrls: ['./admin-navigation.component.scss']
})
export class AdminNavigationComponent implements OnInit {

    public showSearch = false;

    constructor(private modalService: NgbModal) {
    }

    ngOnInit() {
    }

}
